import { render } from "./orders-fundings-block.vue?vue&type=template&id=354e3508&scoped=true"
import script from "./orders-fundings-block.vue?vue&type=script&lang=js"
export * from "./orders-fundings-block.vue?vue&type=script&lang=js"

import "./orders-fundings-block.vue?vue&type=style&index=0&id=354e3508&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-354e3508"]])

export default __exports__